import dynamicExtendingSearchApi from "~/api/dynamic_extending_search";

const getDynamicExtendingSearchesByIds = (
  context,
  dynamicExtendingSearchId,
) => dynamicExtendingSearchApi
  .getDynamicExtendingSearchesByIds(dynamicExtendingSearchId)
  .then((response) => response.data);

export default {
  getDynamicExtendingSearchesByIds,
};
